/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api';
export default {
  getFiscalData: function(config) {
    return apiCtrl.get('/admin/aplifisa/fiscal', config);
  },

  getContactsOfCompany: function(clavedat) {
    return apiCtrl.get('/admin/aplifisa/fiscal/contacts/' + clavedat);
  },

  getFiscalDetail: function(clavedat) {
    return apiCtrl.get('/admin/aplifisa/fiscal/' + clavedat + '/detail');
  },

  getFiscalDataRaw: function() {
    return apiCtrl.get('/admin/aplifisa/gfis/raw/');
  },
  getCustomerDataRaw: function(clavedat) {
    return apiCtrl.get('/aplifisa/gfis/' + clavedat);
  },

  getFiscalDataInputSelect: function(config) {
    return apiCtrl.get('/admin/aplifisa/fiscal/input-select', config);
  },
};
